import React, { useEffect, useState } from "react"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import { listProjects, deleteProject } from "../api"
import ProjectEditor from "./ProjectEditor"

const ProjectList = ({ orgId }) => {
  const [projects, setProjects] = useState([])
  const [loading, setLoading] = useState(false)
  const [editing, setEditing] = useState(null)

  const refresh = async () => {
    setLoading(true)
    const r = await listProjects(orgId)
    setProjects(r?.projects || [])
    setLoading(false)
  }

  useEffect(() => { refresh() }, [orgId])

  const handleDelete = async (p) => {
    if (!confirm(`Delete project "${p.name}"? This removes all components and incidents.`)) return
    await deleteProject(p._id)
    refresh()
  }

  if (editing !== null) {
    return (
      <ProjectEditor
        orgId={orgId}
        project={editing}
        onClose={() => { setEditing(null); refresh() }}
      />
    )
  }

  return (
    <div className="p-6 space-y-4">
      <div className="flex items-center justify-between">
        <Typography variant="admin_h2">Projects</Typography>
        <Button onClick={() => setEditing({})}>New project</Button>
      </div>
      {loading && <div>Loading...</div>}
      {!loading && projects.length === 0 && <div className="text-admin_muted">No projects yet.</div>}
      <div className="grid gap-3">
        {projects.map((p) => (
          <div key={p._id} className="p-4 rounded-lg bg-admin_paper flex items-center justify-between">
            <div>
              <div className="font-semibold">{p.name}</div>
              <div className="text-xs text-admin_muted">{p.slug} · role: {p._role}{p.public ? ` · public: ${p.publicSlug}` : ""}</div>
            </div>
            <div className="flex gap-2">
              <Button variant="secondary" onClick={() => setEditing(p)}>Edit</Button>
              {p._role === "owner" && (
                <Button variant="danger" onClick={() => handleDelete(p)}>Delete</Button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ProjectList
